// For people with more than one area (e.g. staff who are also set up as a client manager).
import { useState } from 'react'
import { AREA_INFO, type Area } from '@briary/shared'
import { api } from '../../lib/api'
import { useAuth } from '../../lib/auth'
import { useRouter } from '../../lib/router'
import { Icon } from '../../ui'
import { AuthLayout } from './AuthLayout'

export default function Choose() {
  const { me, refresh } = useAuth()
  const { navigate } = useRouter()
  const [busy, setBusy] = useState<Area | null>(null)
  if (!me) return null

  const pick = async (area: Area) => {
    setBusy(area)
    await api.post('/api/auth/area', { area }).catch(() => {})
    await refresh()
    navigate(`/${area}`, { replace: true })
  }

  return (
    <AuthLayout title="Where to?">
      <h2>Where would you like to go?</h2>
      <p className="lead">You have access to more than one part of Briary Hub. We’ll remember your choice, and you can switch any time from the top bar.</p>
      <div className="area-choice">
        {me.areas.map((a) => (
          <button key={a} onClick={() => void pick(a)} disabled={busy !== null}>
            <span className="icon">
              <Icon name={a === 'admin' ? 'building' : a === 'portal' ? 'folder' : 'wind'} />
            </span>
            <span>
              <strong>{AREA_INFO[a].label}</strong>
              <span>{AREA_INFO[a].description}</span>
            </span>
            {busy === a ? <span className="spinner" style={{ marginLeft: 'auto' }} /> : <Icon name="arrow" width={18} height={18} style={{ marginLeft: 'auto', color: 'var(--text-3)' }} />}
          </button>
        ))}
      </div>
    </AuthLayout>
  )
}
